export default function hamburger() {
    // Hamburger Menu
    var hamburger = document.querySelector(".hamburger");
    hamburger.addEventListener("click", function () {
        hamburger.classList.toggle("is-active");
    });
}
